import React, { useEffect } from "react";
import "./N_servicios.css";
import { FaFolder, FaSearch, FaBook, FaBrain, FaLightbulb, FaBookOpen, FaLink, FaChartBar, FaFilm, FaMicrophone, FaHeadphones, FaPuzzlePiece, FaQuestionCircle, FaGamepad, FaCloud, FaSyncAlt, FaCompass, FaLaptop, FaGlobe, FaUniversity } from "react-icons/fa";
import { FaPhotoVideo } from "react-icons/fa"; // ✅ recomendado
import { FaRegFileAlt } from "react-icons/fa";
import { Helmet } from "react-helmet";



import imgquienes_somosContenidoDigital from '../assets/img1_quienes_somos_contenido_digital.jpeg';
import image2 from '../assets/img2_quienes_somos_contenido_digital.jpg';
import image3 from '../assets/img3_quienes_somos_contenido_digital.jpg';
import image4 from '../assets/img4_quienes_somos_contenido_digital.jpg';
import image5 from '../assets/img5_quienes_somos_contenido_digital.jpg';
import image6 from '../assets/img6_quienes_somos_contenido_digital.jpg';
import image7 from '../assets/img7_quienes_somos_contenido_digital.jpg';
import image8 from '../assets/img8_quienes_somos_contenido_digital.jpg';
import image9 from '../assets/img9_quienes_somos_contenido_digital_.png';
import imgDerecho from '../assets/img11_quienes_somos_contenido_digital.jpeg';
import imgMarketing from '../assets/img10_quienes_somos_contenido_digital.jpeg';
import image12 from '../assets/img12_quienes_somos_contenido_digital.jpeg';
import imgTrigo from '../assets/img_trigo_contenido_digital.jpeg';
import imgBio from '../assets/img_bio_contenido_digital.jpg';




const N_servicios = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
        <Helmet>
              <title>EduIALogic | eduialogic | Eduialogic | Transformamos la educación digital en Colombia</title>
              <meta
                name="description"
                content="Virtualizamos contenidos educativos con pedagogía de calidad, tecnología ágil y producción de bajo costo para todos los niveles de formación."
              />
              <link rel="canonical" href="https://www.eduialogic.com/" />
        </Helmet>
    <section id="servicios" className="servicios-container">
      <div className="hero_2">
        <h2_8>¿Quienes somos y como lo hacemos?</h2_8>
        
      </div>
      <div className="hero_3">
        
        <p className="intro_2">
          EduIALogic es un equipo de creativos digitales y tecnopedagogos convencidos de que es posible digitalizar contenidos educativos de alta calidad pedagógica, de forma rápida y con costos accesibles.
        </p>
        <br />
        
         <p className="intro_3">
          Nos basamos en el modelo R-Learning 360°: 
        </p>
        <p className="intro_3">
          Una experiencia potente de aprendizaje virtual en 11 pasos, diseñada para dar vida pedagógica y didáctica a los contenidos educativos digitalizados y responder a las necesidades de las instituciones educativas.
        </p>

        <div className="imagen-contenido-digital">
            <img src={imgquienes_somosContenidoDigital} alt="Contenido Digital EduIALogic" />
          </div>
        
        <br />
        <br />
        <p className="intro_3">
          ¡Somos tus aliados estratégicos, cada uno de nosotros hace realidad tus metas de virtualización!
        </p>

         <br />

        <div className="recursos-grid-2">
            {[
              { img: image2, titulo: 'Directora de Innovación Educativa y Estrategia Digital', detalle: 'Lidero la visión general del proyecto, integrando pedagogía, tecnología y creatividad para asegurar que cada contenido digital cumpla con altos estándares de calidad, escalabilidad y eficiencia. Coordino al equipo multidisciplinario, defino lineamientos estratégicos y me aseguro de que todo esté alineado con el modelo R-Learning 360° y con las necesidades reales de las instituciones educativas.'},
              { img: image3, titulo: 'Analistas Académicos', detalle: 'Nos encargamos de analizar cuidadosamente la Guía de Contenidos que nos entrega la Institución educativa. De ahí extractamos los temas claves, los resultados de aprendizaje y todo lo necesario para comenzar bien el trabajo. Esa guía es el mapa que nos dice por dónde debemos desplegar el diseño instruccional.' },
              { img: image4, titulo: 'Investigadores de Contenidos y Expertos Temáticos', detalle: 'Lo que hacemos es realizar una investigación documental y una curaduría cuidadosa de libros, artículos científicos y documentos confiables y actuales que sustenten los temas disciplinares. Juntos redactamos las ideas más importantes, los guiones de los recursos audiovisuales, las evaluaciones, los talleres y estudios de caso.' },
              { img: image5, titulo: 'Asesores Pedagógicos ', detalle: 'Nuestro trabajo es asegurarnos que todo el contenido esté pensado para que los estudiantes realmente aprendan. Revisamos que las actividades tengan sentido con los resultados de aprendizaje y/o con las competencias previstas y que todo esté alineado con el Modelo R-Learning 360º' },
              { img: image6, titulo: 'Diseñadores Conceptuales y Audiovisuales', detalle: 'Con base en los textos disciplinares y en los aportes pedagógicos diseñamos diagramas, gráficos, infografías, líneas de tiempo. Igualmente, realizamos la producción de videos y de podcats. En general garantizamos que el contenido sea agradable en su interfaz gráfica y visual.' },
              { img: image7 , titulo: 'Diseñadores de Experiencias Interactivas', detalle: 'Nos encargamos de diseñar la interactividad de los recursos, cargar todos los contenidos en la plataforma de navegación y verificar que cada enlace funcione correctamente para garantizar una experiencia fluida y sin errores' },
              
            ].map((item2, index2) => (
              <div className="recurso-item" key={index2}>
                <img src={item2.img} alt={item2.titulo} />
                <h4>{item2.titulo}</h4>
                <p>{item2.detalle}</p>
              </div>
            ))}
          </div>

           <br />
           <br />

          <p className="intro_17">

          Líder de Desarrollo de Software

          </p>
          <br />

          <p className="intro_16">
          Me encargo de brindar soporte tecnológico, desarrollar y mantener plataformas web, asegurar la funcionalidad de los contenidos digitales y garantizar una experiencia de navegación fluida, segura y sin interrupciones. Además, acompaño al equipo en la implementación técnica de los recursos diseñados bajo el modelo R-Learning 360°.
          </p>
          <br />

          <div className="imagen-contenido-digital">
            <img src={image8} alt="Contenido Digital EduIALogic" />
          </div>
          <br />
          <br />
          <br />
          <p className="intro_2">
          ¿Cómo es el proceso de producción de digitalización de una una asignatura? 
          </p>
          <br />
          <br />

          <p className="intro_4">
          En EduIALogic, digitalizar una asignatura no es un proceso técnico cualquiera: es una experiencia cuidadosamente diseñada. Nuestro modelo R-Learning 360° aplica una secuencia pedagógica estratégica basada en fundamentos teóricos sólidos y criterios disciplinares actualizados.Desde el primer paso hasta la entrega final, desplegamos un ecosistema completo de recursos tecnopedagógicos, creados con inteligencia, creatividad y enfoque metodológico. 
          </p>
          <br />
          <p className="intro_5">
            🔄 No improvisamos contenidos, los diseñamos con estrategia instruccional.
          </p>
          <p className="intro_5">
            📚 No solo digitalizamos asignaturas, creamos experiencias de aprendizaje.
          </p>
          <p className="intro_5">
            🚀 Cada asignatura es una producción de alto impacto pedagógico.
          </p>
          <br />
          
          <p className="intro_3">
           Te invitamos a descubrir, step by step, cómo transformamos tus asignaturas en experiencias virtuales de aprendizaje memorables
          </p>
          <br />
          <br />
          {/* Grilla de pasos */}
          <div className="grid-steps-container">
            {[
              {
                title: 'Step 1 GO!',
                description: 'Partimos de lo más valioso: tu Guía de Contenidos. A partir de ella construimos un diseño digital sólido, coherente y alineado con tus propósitos académicos.',
                icons: ['📁', '🔍'],
              },
              {
                title: 'Step 2',
                description: 'Respaldamos cada contenido con una investigación documental rigurosa y curada, basada en fuentes científicas de alta calidad que fortalecen los fundamentos disciplinares. Si la institución lo prefiere, también puede aportar sus propios libros, artículos o normas de referencia para asegurar plena coherencia con su enfoque académico.',
                icons: ['📚', '🧠'],
              },
              {
                title: 'Step 3',
                description: 'Extraemos las ideas clave y los postulados esenciales de cada fuente para construir los fundamentos teóricos que dan solidez académica y coherencia conceptual  a toda la asignatura. Este proceso no solo garantiza el rigor intelectual del contenido, sino que también permite conectar cada recurso tecnopedagógico con principios científicos y enfoques disciplinares actualizados.',
                icons: ['💡', '📖'],
              },
              {
                title: 'Step 4',
                description: 'Con base en los fundamentos teóricos, desarrollamos la ideación gráfica conceptual y los diagramas lógicos que dan forma visual y estructural a los contenidos. Este proceso convierte el conocimiento en experiencias claras, intuitivas y pedagógicamente efectivas.',
                icons: ['🔗', '📊'],
              },
              {
                title: 'Step 5',
                description: 'A partir de las fuentes científicas cuidadosamente seleccionadas, elaboramos los guiones de los videos y podcasts, asegurando que cada pieza audiovisual transmita contenidos rigurosos, claros y alineados con los objetivos de aprendizaje.',
                icons: ['🎬', '🎙️'],
              },
              {
                title: 'Step 6',
                description: 'Realizamos la postproducción audiovisual para dar forma final a cada recurso: edición, montaje, efectos y ajustes técnicos que garantizan calidad visual, claridad comunicativa y coherencia pedagógica.',
                icons: ['🎞️', '🎧'],
              },
              {
                title: 'Step 7',
                description: 'Diseñamos talleres y estudios de caso completamente alineados con los objetivos de aprendizaje, resultados esperados o competencias del curso, según corresponda. Cada actividad está pensada para consolidar el conocimiento, fomentar el pensamiento crítico y promover la aplicación práctica en contextos reales.',
                icons: ['🧩', '📝'],
              },
              {
                title: 'Step 8',
                description: 'Diseñamos preguntas autoevaluativas interactivas basadas en fuentes científicas confiables, y las integramos en un aplicativo de gamificación que convierte la evaluación en una experiencia dinámica, divertida y pedagógicamente sólida.',
                icons: ['❓', '🎮'],
              },
              {
                title: 'Step 9',
                description: 'Diseñamos preguntas de reflexión y recordación basadas en fuentes científicas, orientadas a profundizar la comprensión, activar el pensamiento crítico y reforzar los aprendizajes clave.',
                icons: ['☁️', '🔄'],
              },
              {
                title: 'Step 10',
                description: 'Desarrollamos el guion de la historia ramificada con base en situaciones realistas y decisiones clave, y lo integramos en un aplicativo de simulación narrativa interactiva que coloca al estudiante en el centro del aprendizaje.',
                icons: ['📖', '🧭'],
              },
              {
                title: 'Step 11',
                description: 'Una vez creados, todos los recursos se cargan en la plataforma de gestión, donde EduIALogic transforma el contenido en una experiencia navegable, intuitiva y lista para el aula virtual.',
                icons: ['💻', '🌐'],
              },
              {
                title: 'Final Step!',
                description: 'Finalmente, el contenido cobra vida en tu ecosistema digital. Se integra fácilmente en la MLS de la institución educativa —ya sea mediante URL, iframe o SCORM— según el acuerdo de entrega. Así, cada experiencia de aprendizaje diseñada por EduIALogic llega directo a tus estudiantes, sin barreras, sin complicaciones.',
                icons: ['🏛️', '🔗'],
              },
              ].map((step, index) => (
                <div className={`grid-step-item item-${index % 4}`} key={index}>
                  <div className="blue-line"></div>
                  <h3 className="step-title">
                    <span className="step-icons" style={{ marginRight: '10px' }}>
                      {step.icons.map((emoji, i) => (
                        <span key={i} style={{ marginRight: '6px', fontSize: '1.5rem' }}>{emoji}</span>
                      ))}
                    </span>
                    {step.title}
                  </h3>

                  <p className="step-description">{step.description}</p>
                </div>
              ))}
            </div>

          <br />
          
         
         <div className="imagen-contenido-digital">
            <img src={image9} alt="Contenido Digital EduIALogic" />
          </div>
          <br />
          <br />
        <p className="intro_2">
           ¿Quieres ver una asignatura digitalizada por nuestro equipo?
          </p>
          <br />
          <p className="intro_3">
           Estos son algunos ejemplos reales de asignaturas transformadas con R-Learning 360°: calidad, estructura y experiencia virtual completa en 11 pasos.
          </p>

          <div className="grid-cursos">
            <div className="curso-card">
              <img src={imgDerecho} alt="Derecho Penal" className="curso-img" />
              <h3>Derecho Penal</h3>
              <p>Asignatura de pregrado</p>
              <a
                href="https://gamma.app/docs/Derecho-Penal-General-l30reok9jr95d33"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>

            <div className="curso-card">
              <img src={imgMarketing} alt="Marketing Digital" className="curso-img" />
              <h3>Fundamentos del Marketing Digital</h3>
              <p>Asignatura de Maestría o de especialización</p>
              <a
                href="https://gamma.app/docs/Fundamentos-del-Marketing-Digital-th1wmg9rybb69a5"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>

            <div className="curso-card">
              <img src={imgTrigo} alt="Trigonometría" className="curso-img_1" />
              <h3>Geometría y Trigonometría</h3>
              <p>Asignatura de grado 11 de Bachillerato</p>
              <a
                href="https://gamma.app/docs/GEOMETRIA-Y-TRIGONOMETRIA-zwd7scg8rs6d77a"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>

            <div className="curso-card">
              <img src={imgBio} alt="Biología" className="curso-img_1" />
              <h3>Biología</h3>
              <p>Asignatura de grado quinto de Primaria</p>
              <a
                href="https://gamma.app/docs/BIOLOGIA-rahfqgx8u8tvcw7"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>
          </div>

          <br />
          <br />

          <h2>EduIALogic se pone la camiseta por tu institución.</h2>
          <p className="intro_3">
           ¡Juntos transformamos la educación, paso a paso!
          </p>
          <br />

           <div className="imagen-contenido-digital">
            <img src={image12} alt="Contenido Digital EduIALogic" />
          </div>
          

      </div>



    </section>
    </>
  );
};

export default N_servicios;
